import * as Yup from 'yup';

export interface AddEventFormValues {
  image: File | null;
  name: string;
  startDate: Date | null;
  endDate: Date | null;
  description: string;
  option1?: string | null;
  option2?: string | null;
  option3?: string | null;
}

export const defaultValues: AddEventFormValues = {
  image: null,
  name: '',
  startDate: null,
  endDate: null,
  description: '',
  option1: '',
  option2: '',
  option3: '',
};

export const createValidationSchema = Yup.object().shape({
  image: Yup.mixed().required('Image is required'),
  name: Yup.string().required('Name is required'),
  startDate: Yup.date().required('Start date is required'),
  endDate: Yup.date()
    .required('End date is required')
    .min(Yup.ref('startDate'), 'End date must be after start date'),
  description: Yup.string().required('Description is required'),
  option1: Yup.string()
    .nullable()
    .transform((value) => (!value ? '' : value)),
  option2: Yup.string()
    .nullable()
    .transform((value) => (!value ? '' : value)),
  option3: Yup.string()
    .nullable()
    .transform((value) => (!value ? '' : value)),
});

export const updateValidationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  startDate: Yup.date().required('Start date is required'),
  endDate: Yup.date()
    .required('End date is required')
    .min(Yup.ref('startDate'), 'End date must be after start date'),
  description: Yup.string().required('Description is required'),
  option1: Yup.string()
    .nullable()
    .transform((value) => (!value ? '' : value)),
  option2: Yup.string()
    .nullable()
    .transform((value) => (!value ? '' : value)),
  option3: Yup.string()
    .nullable()
    .transform((value) => (!value ? '' : value)),
});

export const validationSchema = createValidationSchema;
